import React from 'react';
import { Box, Typography, CircularProgress, Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const UnderDevelopment = () => {
  const navigate = useNavigate();
  return (
    <Box>
      <Button
        startIcon={<ArrowBack />}
        onClick={() => navigate(-1)}
        className='self-start mb-8 normal-case !text-primary'
        sx={{
          textTransform: 'none',
          padding: '6px 16px'
        }}
      >
        Go Back
      </Button>
      <Box className='flex flex-col items-center justify-center min-h-[60vh] p-6 text-center'>
        <Box className='mb-6'>
          <CircularProgress size={50} className='!text-primary' />
        </Box>

        <Typography variant='h4' className='mb-2 font-bold text-gray-800' sx={{ fontWeight: 700 }}>
          Under Development
        </Typography>

        <Typography variant='body1' className='max-w-md text-gray-600 mb-6'>
          We're working hard to bring you this feature soon. Please check back later!
        </Typography>
      </Box>
    </Box>
  );
};

export default UnderDevelopment;
